module.exports = __webpack_public_path__ + "img/img_szcert.56170d30.png";